import {getTeamCoaches} from '@/api/api';
import {Profile} from '@/user/player-info.interface';
import {useQuery} from '@tanstack/react-query';

export const useGetTeamCoaches = (teamId: string) => {
  return useQuery<Profile[]>({
    queryKey: ['team-coaches', teamId],
    queryFn: () => getTeamCoaches(teamId),
    enabled: !!teamId,
  });
};
